import axios from "../axiosInstance";
import type { CourseWithDetails } from "@/modules/learningCenter/types/course";

export interface PublishCourseResponse {
  message: string;
  course: CourseWithDetails;
}

/**
 * Publish a course (draft -> published).
 *
 * PATCH /api/learning-center/courses/{id}/publish
 */
export const publishCourse = async (
  id: number,
): Promise<PublishCourseResponse> => {
  const response = await axios.patch<PublishCourseResponse>(
    `/api/learning-center/courses/${id}/publish`,
  );
  return response.data;
};

export default publishCourse;
